var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-2"},[_c('InfoCompetence',{attrs:{"data":_vm.competenceWithChildren,"title":_vm.$gettext('Comparativa')}},[_c('SelectCenters',{staticClass:"my-4",attrs:{"items":_vm.centers,"itemsChecked":_vm.centersActive},on:{"setItems":_vm.setItems}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }